<template>
  <action-dispatcher
    action="courses/getDetails"
    :parameters="$route.params.id"
    ref="coursesDispatcher"
    class="view-course"
  >
    <header
      :style="
        `background-image: linear-gradient(to right, #0000, #0008 60%), url(${course.cover})`
      "
    >
      <div class="container py-lg-5 text-light">
        <div class="course-header">
          <div class="row align-items-center justify-content-center">
            <div class="col-8 col-lg-5 py-4"></div>
            <div class="col-12 col-lg-7 py-4">
              <div class="card">
                <div class="card-body p-lg-5">
                  <h1 class="text-uppercase">{{ course.title }}</h1>
                  <small class="d-block my-3">{{ numLessons }} aulas</small>
                  <h5>SOBRE O CURSO</h5>
                  <div class="course-description" v-html="course.description" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section class="bg-black">
      <div class="container py-5">
        <lessons-list class="order-lg-2" :course="course" />
      </div>
    </section>
  </action-dispatcher>
</template>

<script>
import LessonsList from "../components/course/LessonsList";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  components: { LessonsList },
  computed: {
    ...mapState("courses", ["course"]),
    currentLesson() {
      return (
        this.course &&
        this.course.lessons &&
        this.course.lessons.find(
          lesson => !lesson.progress || !lesson.progress.finished_at
        )
      );
    },
    numLessons() {
      return get(this.course, "lessons.length", 0);
    },
    category() {
      return get(this.course, "lessons[0].category.name", "");
    },
    time() {
      const getMinutes = timeStr =>
        timeStr
          ? parseInt(timeStr) * 60 +
            parseInt(get(`${timeStr}`.split(":"), "[1]", 0))
          : 0;
      const minutes =
        5 +
        get(this.course, "lessons", []).reduce(
          (prev, cur) => prev + getMinutes(cur.duration),
          0
        );
      return Math.round(minutes / 60);
    }
  }
};
</script>

<style lang="scss" scoped>
.view-course {
  @media screen and (max-width: 991px) {
    flex-direction: column-reverse;
  }

  .course-description {
    font-size: 18px;
    color: #d7d7d7;
  }

  .course-header {
    text-shadow: 0 2px 10px black;

    .card {
      background-color: #000c;
      box-shadow: 0 4px 16px #000c;
      border-radius: 16px;
    }

    .circle {
      border: 3px solid #1a78a1;
      border-radius: 100%;
    }
  }

  a {
    line-height: 34px;
  }

  button {
    i {
      font-size: 22px;
    }
  }

  .media {
    @media screen and (max-width: 767px) {
      img,
      .btn,
      .media-body > * {
        width: 100%;
        height: auto;
      }
      h1 {
        font-size: 24px;
      }
    }
  }

  header {
    background-image: url("../assets/images/course-bg-2.jpg");
  }
}
</style>
